import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EmployeeListHrisLocationFragment = { __typename?: 'HrisLocation', id: number, name: string };

export type EmployeeListHrisTeamFragment = { __typename?: 'HrisTeam', id: number, name: string };

export type HrisEmployeeFragment = { __typename?: 'HrisEmployee', id: number, createdAt: string, updatedAt: string, firstName: string, lastName: string, phoneNumber?: string | null, remoteHrisId: string, employmentStatus?: string | null, startDate?: string | null, terminationDate?: string | null, lastModifiedByMergeBackfillRunId?: number | null, locationMemberships: Array<{ __typename?: 'HrisEmployeeLocationMembership', id: string, location: { __typename?: 'HrisLocation', id: number, name: string } }>, teamMemberships: Array<{ __typename?: 'HrisEmployeeTeamMembership', id: string, team: { __typename?: 'HrisTeam', id: number, name: string } }>, user?: { __typename?: 'Employee', id: number, name: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null, csvUpload?: { __typename?: 'HrisCsvUpload', id: string, csvUrl: string } | null };

export type HrisEmployeesQueryVariables = Types.Exact<{
  input: Types.HrisEmployeesInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisEmployeesQuery = { __typename?: 'Query', HrisEmployees: { __typename?: 'HrisEmployees', totalCount: number, objects: Array<{ __typename?: 'HrisEmployee', id: number, createdAt: string, updatedAt: string, firstName: string, lastName: string, phoneNumber?: string | null, remoteHrisId: string, employmentStatus?: string | null, startDate?: string | null, terminationDate?: string | null, lastModifiedByMergeBackfillRunId?: number | null, locationMemberships: Array<{ __typename?: 'HrisEmployeeLocationMembership', id: string, location: { __typename?: 'HrisLocation', id: number, name: string } }>, teamMemberships: Array<{ __typename?: 'HrisEmployeeTeamMembership', id: string, team: { __typename?: 'HrisTeam', id: number, name: string } }>, user?: { __typename?: 'Employee', id: number, name: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null, csvUpload?: { __typename?: 'HrisCsvUpload', id: string, csvUrl: string } | null }> } };

export type DeleteHrisEmployeesMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type DeleteHrisEmployeesMutation = { __typename?: 'Mutation', deleteHrisEmployees: { __typename?: 'GenericMutationResult', success: boolean } };

export const EmployeeListHrisLocationFragmentDoc = gql`
    fragment EmployeeListHrisLocation on HrisLocation {
  id
  name
}
    `;
export const EmployeeListHrisTeamFragmentDoc = gql`
    fragment EmployeeListHrisTeam on HrisTeam {
  id
  name
}
    `;
export const HrisEmployeeFragmentDoc = gql`
    fragment HrisEmployee on HrisEmployee {
  id
  createdAt
  updatedAt
  firstName
  lastName
  phoneNumber
  remoteHrisId
  locationMemberships {
    id
    location {
      ...EmployeeListHrisLocation
    }
  }
  teamMemberships {
    id
    team {
      ...EmployeeListHrisTeam
    }
  }
  employmentStatus
  startDate
  terminationDate
  user {
    id
    name
  }
  hrisIntegration {
    id
    hrisProvider
  }
  lastModifiedByMergeBackfillRunId
  csvUpload {
    id
    csvUrl
  }
}
    ${EmployeeListHrisLocationFragmentDoc}
${EmployeeListHrisTeamFragmentDoc}`;
export const HrisEmployeesDocument = gql`
    query HrisEmployees($input: HrisEmployeesInput!, $pagination: PaginationInput) {
  HrisEmployees(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...HrisEmployee
    }
  }
}
    ${HrisEmployeeFragmentDoc}`;

/**
 * __useHrisEmployeesQuery__
 *
 * To run a query within a React component, call `useHrisEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisEmployeesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisEmployeesQuery(baseOptions: Apollo.QueryHookOptions<HrisEmployeesQuery, HrisEmployeesQueryVariables> & ({ variables: HrisEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisEmployeesQuery, HrisEmployeesQueryVariables>(HrisEmployeesDocument, options);
      }
export function useHrisEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisEmployeesQuery, HrisEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisEmployeesQuery, HrisEmployeesQueryVariables>(HrisEmployeesDocument, options);
        }
export type HrisEmployeesQueryHookResult = ReturnType<typeof useHrisEmployeesQuery>;
export type HrisEmployeesLazyQueryHookResult = ReturnType<typeof useHrisEmployeesLazyQuery>;
export type HrisEmployeesQueryResult = Apollo.QueryResult<HrisEmployeesQuery, HrisEmployeesQueryVariables>;
export const DeleteHrisEmployeesDocument = gql`
    mutation DeleteHrisEmployees($ids: [Int!]!) {
  deleteHrisEmployees(ids: $ids) {
    success
  }
}
    `;
export type DeleteHrisEmployeesMutationFn = Apollo.MutationFunction<DeleteHrisEmployeesMutation, DeleteHrisEmployeesMutationVariables>;

/**
 * __useDeleteHrisEmployeesMutation__
 *
 * To run a mutation, you first call `useDeleteHrisEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHrisEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHrisEmployeesMutation, { data, loading, error }] = useDeleteHrisEmployeesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteHrisEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHrisEmployeesMutation, DeleteHrisEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHrisEmployeesMutation, DeleteHrisEmployeesMutationVariables>(DeleteHrisEmployeesDocument, options);
      }
export type DeleteHrisEmployeesMutationHookResult = ReturnType<typeof useDeleteHrisEmployeesMutation>;
export type DeleteHrisEmployeesMutationResult = Apollo.MutationResult<DeleteHrisEmployeesMutation>;
export type DeleteHrisEmployeesMutationOptions = Apollo.BaseMutationOptions<DeleteHrisEmployeesMutation, DeleteHrisEmployeesMutationVariables>;